import moment from 'moment';
import {Json} from "../client/Json";

type BookingRoom = {
    roomId: number,
    roomRate: number
}

export type BookingInfo = {
    id: number,
    guest: {
        name: string,
        email: string,
        phone: string
    },
    details: {
        requests: string,
        currency: number,
        numGuests: number,
        bookingRooms: BookingRoom[]
        checkIn: Date,
        checkOut: Date
    }
    approved: boolean,
}

export type BookingInfoPatch = {
    approved: boolean,
}

export function BookingInfoFromJson(json: Json<BookingInfo>) : BookingInfo {
    const { details: {checkIn, checkOut, ...a}, ...b } = json;
    return {
        details: {
            checkIn: moment(checkIn, 'YYYY-MM-DD').toDate(),
            checkOut: moment(checkOut, 'YYYY-MM-DD').toDate(),
            ...a
        },
        ...b
    }
}